// The colour-coded health-state badge shown on the party cards and the
// initiative rows. Presentational only: the state is derived in
// state/healthState.ts and passed in, so both surfaces read identically.
//
// A null state renders nothing — an unknown HP has no honest badge to show
// (see "ABSENT IS NOT ZERO" in healthState.ts).
import type { HealthState } from "../state/healthState";
import { HEALTH_META } from "../state/healthState";

export function HealthBadge({ state }: { state: HealthState | null }) {
  if (!state) return null;
  const meta = HEALTH_META[state];
  return (
    <span className={`health-badge state-${state}`} title={meta.title}>
      <span className="dot" aria-hidden="true" />
      {meta.label}
    </span>
  );
}
